// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"6715d983","180":"35a26b79","237":"4f60078e","357":"258fd3db","423":"545ce151","439":"90f9342b","453":"03346f77","467":"ee2a564e","535":"c8ed9216","595":"057f0f51","718":"009b83f2","783":"b4f1fc01","874":"b8b86afd"}[chunkId] + ".chunk.js";
};